module.exports = __webpack_public_path__ + "images/eurocoverb4ff783c212f3cc7276116fdeef1857b.png";